module.exports = __webpack_public_path__ + "img/45deg.8bbf6c31.svg";